import React, { useContext, useState } from 'react';

import { ApiRoutes, FetchContext, HttpMethods, ToastContext } from '../../contexts';

import { useAggregatedState } from '../../../helpers';

export const StoricoUfficioComuneCompetenzaContext = React.createContext(null);

const { Provider } = StoricoUfficioComuneCompetenzaContext;

export const StoricoUfficioComuneCompetenzaProvider = (props) => {
    const {
        showWarningMessage,
        showSuccessMessage,
        showErrorMessage
    } = useContext(ToastContext);
    const { fetchOk, fetchAuthorized } = useContext(FetchContext);
    const [state, setState] = useAggregatedState({
        storicoUfficioComuneCompetenza: null,
    });

    const {
    } = state;

    const [isLoadingStoricoUfficioComuneCompetenza, setIsLoadingStoricoUfficioComuneCompetenza] = useState(false);
    const getStoricoUfficioComuneCompetenzaAsync = async (comuneId, competenzaId, storicoId) => {
        try {
            setIsLoadingStoricoUfficioComuneCompetenza(true);
            const r = await fetchAuthorized(ApiRoutes.Comune.GetStorico({ comuneId, competenzaId, storicoId }), {
                method: HttpMethods.GET
            });
            const result = await r.json();
            result.dataCreazione = new Date(result.dataCreazione);
            result.valore = JSON.parse(result.valore);
            result.valorePrecedente = JSON.parse(result.valorePrecedente);
            setState({ storicoUfficioComuneCompetenza: result });
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingStoricoUfficioComuneCompetenza(false);
        }
    }

    return (
        <Provider value={{
            state,
            setState,

            isLoadingStoricoUfficioComuneCompetenza,
            getStoricoUfficioComuneCompetenzaAsync,
        }}>
            {props.children}
        </Provider>
    );
}